(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[9],{

/***/ "BM/k":
/***/ (function(module, exports) {

function formatJetHat(did) {
    if (!did) {
        return "";
    }
    if (did.length === 10) {
        return "0"+did;
    }
    return did;
}

function replaceHtmlWithJethat(htmlContent, jetHatNumber) {
  const jethatContent =
    "<span style='font-size: 14px; font-weight: 200'><b>JetHat</b> ile extra ücret ödemeden arayın. \
        <br/>\
        <a href='tel:" + jetHatNumber + "' style='bold; color: #52ca46'>\
          <b>Hemen Ara</b>\
        </a>\
      </span>";

  return htmlContent.replace(/([+\(\)\/\-]?(\d([^a-wyzçmşığÇŞİĞ\n]|(&[a-zA-Z0-9]*;))*){9}\d{1})/ig, jethatContent);
}

function getRawNumber(phoneNumber) {
    var raw = null;
    if(phoneNumber) {
        raw = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        if(raw.length == 11) {
            raw = raw.slice(1);
        }
    }
    return raw;
}

module.exports = {
    formatJetHat: formatJetHat,
    replaceHtmlWithJethat: replaceHtmlWithJethat,
    getRawNumber: getRawNumber
}



/***/ }),

/***/ "JlvA":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"bpioL7","sponsorAndLogo":"_1TSIeK","socialBar":"_2uhNER","logos":"_1kro7r","buttonList":"AeTsgd"};

/***/ }),

/***/ "PdCH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return highlightParagraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return phoneMasking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPhoneView; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("BM/k");
/* harmony import */ var _emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1__);



var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var baseURL = publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname;

var highlightParagraph = function highlightParagraph(input, textToHighlight) {
  return input.replace(new RegExp(textToHighlight, 'gi'), "<strong><u>$&</u></strong>");
};

var phoneMasking = function phoneMasking(input, jethat, listingId) {
  if (input) {
    var eventMessage = "var eventData = { channel: 'DESKTOP_WEB', reason: 'LISTING_DETAIL', context: 'LISTING', event: 'VIEW_PHONE_LISTING', entityId: ".concat(listingId, "};");
    var xhr = " var xmlhttp = new XMLHttpRequest();   // new HttpRequest instance \n                    var eventUrl = \"".concat(baseURL, "/e6t/v1/listing/").concat(listingId, "/view-phone?reason=listing_detail\";\n                    xmlhttp.open(\"GET\", eventUrl, true);\n                    xmlhttp.setRequestHeader(\"Content-Type\", \"application/json;charset=UTF-8\");\n                    xmlhttp.send(JSON.stringify(eventData));");
    var showJetHat = "\n      function showJethat(node){\n        node.innerHTML=\"<span style='font-size: 16px; font-weight: bold;'>".concat(jethat, "</span>\";\n        ").concat(eventMessage, "\n        ").concat(xhr, "\n    }");
    var phoneRegexPattern = new RegExp('(((\\+)?[ \\-\\.]*\\d[ \\-\\.]*)?0[ \\-\\.]*((\\(( *))(\\d( *)){3}(\\)( *)))[\\d \\-\\.]*)|(((\\(( *))(\\d( *)){3}(\\)( *)))[\\d \\-\\.]*)|\\+?\\d{12}|\\d{11}', 'ig');
    var replacedText = input.replace(phoneRegexPattern, "\n        <div style=\"display: inline-flex; font-size:14px; font-weight: normal;\">\n          <span style=\"color:black; font-weight:bold !important;\">JetHat</span>\n          &nbsp;ile ekstra \xFCcret \xF6demeden aray\u0131n&nbsp;<span onClick=\"showJethat(this)\">\n          <span style=\"color:#52ca46; cursor: pointer; font-weight:bolder\">Telefona Bak</span>\n        </div>");
    var patterns = [{
      regex: '((\\+[ \\-\\.]*)\\d[\\d \\-\\.]*\\d)',
      size: 12
    }, // + 90 212 344 45 56
    {
      regex: '((\\d[ \\-\\.]*){2} [\\d \\-\\.]*\\d)',
      size: 12
    }, // 90 212 344 45 56
    {
      regex: '( (\\d[ \\-\\.]*){2}\\-[\\d \\-\\.]*\\d)',
      size: 12
    }, // work 9-0-2-1-2-3-4-4-5-5-5-6
    {
      regex: '((\\d\\-){11}\\d)',
      size: 12
    }, // [START OF LINE]9-0-2-1-2-3-4-4-5-5-5-6
    {
      regex: '((\\d[ \\-\\.]*){2} [\\d \\-\\.]*\\d)',
      size: 12
    }, // 9 0 2 1 2 3 4 4 5 5 5 6
    {
      regex: '((\\d[ \\-\\.]*)(\\d[ \\-\\.]*){3}(\\d[ \\.]*)*\\d)',
      size: 11
    }, // covers separately 0532 588 01 41 - 0532 257 27 23
    {
      regex: '(((0\\d{3} \\d{3} \\d{2} \\d{2}) ){3})',
      size: 33
    }, // covers separately 0532 588 01 41 - 0532 257 27 23
    {
      regex: '((\\d[ \\-\\.]*)(\\d[ \\-\\.]*){3}(\\d[ \\-\\.]*)*\\d)',
      size: 11
    }, // 0 212 344 45 56
    {
      regex: '((0\\d{3})[ \\-\\.]?(\\d{3})[ \\-\\.]?(\\d{2})[ \\-\\.]?(\\d{2})[ \\-\\.]?(\\d{10}))',
      size: 21
    }, // 0 212 344 45 56
    {
      regex: '((\\d{3}[ \\-\\.]*)(\\d[ \\-\\.]*)*\\d)',
      size: 10
    }, // 212 344 45 56
    {
      regex: '(((\\d[ \\-]*){3}[ \\-\\.]*)(\\d[ \\-\\.]*)*\\d)',
      size: 10
    }, // 2 1 2 3 4 4 4 5 5 6
    {
      regex: '(\\d[ \\-\\.]*(\\d[ \\-\\.]*)*\\d)',
      size: 7
    } // 344 45 65
    ];
    var phoneNumberRegex = /^([^0-9]*)(((\(0?\+?\d{2,3}\))|((0{1,2})?\+?\d{2,3}))?[\s.-]?((((0?[\s.-]?\d{3})|(\(0?\d{3})\))[\s.-]?(\d{3})[\s.-]?(\d{2}[\s.-]?)(\d{2}))|(\d{4}[\s.-]\d{6})))(.*)$/g;
    patterns.forEach(function (pattern) {
      var compiledRegex = new RegExp(pattern.regex, 'ig');
      var matches = replacedText.match(compiledRegex);
      matches && matches.forEach(function (m) {
        var cleanedMatch = m.replace(/[^\d]/gi, '');
        var hasPhoneNumber = cleanedMatch.length === pattern.size && phoneNumberRegex.test(cleanedMatch);

        if (hasPhoneNumber) {
          replacedText = replacedText.replace(m, "\n                <div style='display: inline-flex; font-size:14px; font-weight: normal;'>\n                    <span style='color:black; font-weight:bold !important;'>JetHat</span>\n                    &nbsp;ile ekstra \xFCcret \xF6demeden aray\u0131n&nbsp;\n                    <span onClick='showJethat(this)'>\n                    <span style='color:#52ca46; cursor: pointer; font-weight:bolder'>Telefona Bak</span>\n                </div>");
        }
      });
    });
    return "\n      <script>\n        function showJethat(node){\n          node.innerHTML=\"<span style='font-size: 16px; font-weight: bold;'>".concat(jethat, "</span>\";\n          ").concat(eventMessage, ";\n          ").concat(xhr, "\n        }\n      </script>\n      ").concat(replacedText, "\n    ");
  }

  return input;
};

var formatPhoneView = function formatPhoneView(listingOwnerPhone) {
  if (typeof listingOwnerPhone === 'number') {
    listingOwnerPhone = listingOwnerPhone.toString();
  }

  if (listingOwnerPhone) {
    if (listingOwnerPhone.length > 11) {
      if (listingOwnerPhone.charAt(0) === '0') {
        listingOwnerPhone = listingOwnerPhone.slice(0, 11);
      } else {
        listingOwnerPhone = listingOwnerPhone.slice(0, 10);
      }

      listingOwnerPhone = Object(_emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1__["formatJetHat"])(listingOwnerPhone);
      return listingOwnerPhone.replace(/(\d\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2 $3');
    }

    if (listingOwnerPhone.length === 10 || listingOwnerPhone.length === 11) {
      listingOwnerPhone = Object(_emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1__["formatJetHat"])(listingOwnerPhone);
      return listingOwnerPhone.replace(/(\d\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2 $3');
    }

    if (listingOwnerPhone.length === 7) {
      listingOwnerPhone = Object(_emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1__["formatJetHat"])(listingOwnerPhone);
      return listingOwnerPhone.replace(/(\d\d\d)(\d\d\d\d)/, '$1 $2');
    }
  }

  return Object(_emlakjet_commons_helpers_phone_number__WEBPACK_IMPORTED_MODULE_1__["formatJetHat"])(listingOwnerPhone);
};



/***/ }),

/***/ "UYDH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailInitialGTMEvent", function() { return listingDetailInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailShowPhoneGtmEvent", function() { return listingDetailShowPhoneGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailSimilarListingsGTMEvent", function() { return listingDetailSimilarListingsGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailClickSimilarItemGtmEvent", function() { return listingDetailClickSimilarItemGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailClickOtherItemGtmEvent", function() { return listingDetailClickOtherItemGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailOtherListViewed", function() { return listingDetailOtherListViewed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailAddFavoriteGtmEvent", function() { return listingDetailAddFavoriteGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailShareGtmEvent", function() { return listingDetailShareGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailSendMessageGtmEvent", function() { return listingDetailSendMessageGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectDetailInitialGTMEvent", function() { return projectDetailInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectDetailViewedGTMEvent", function() { return projectDetailViewedGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectDetailViewedGA4Event", function() { return projectDetailViewedGA4Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectDetailShowPhoneGtmEvent", function() { return projectDetailShowPhoneGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectDetailFormSubmitGTMEvent", function() { return projectDetailFormSubmitGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailListingViewedGTMEvent", function() { return listingDetailListingViewedGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleProjectDetailReleatedProjectsGTMEvent", function() { return handleProjectDetailReleatedProjectsGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "agentPageDetailInitialGTMEvent", function() { return agentPageDetailInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "agentPageDetailListingViewed", function() { return agentPageDetailListingViewed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleAgentDetailGTMEvent", function() { return handleAgentDetailGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "agentDetailShowPhoneGTMEvent", function() { return agentDetailShowPhoneGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "agentDetailAddFavoriteGTMEvent", function() { return agentDetailAddFavoriteGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showCaseInitialGTMEvent", function() { return showCaseInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showCaseListingViewedGTMEvent", function() { return showCaseListingViewedGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleShowcaseListingGTMEvent", function() { return handleShowcaseListingGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showcaseShowPhoneGTMEvent", function() { return showcaseShowPhoneGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showcaseAddFavoriteGTMEvent", function() { return showcaseAddFavoriteGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareInitialGTMEvent", function() { return compareInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareViewedGTMEvent", function() { return compareViewedGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareShowPhoneAndShareGTMEvent", function() { return compareShowPhoneAndShareGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectDetailReleatedProjectViewed", function() { return projectDetailReleatedProjectViewed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteListViewedGTMEvent", function() { return favoriteListViewedGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingDetailListingViewedGA4Event", function() { return listingDetailListingViewedGA4Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ga4ListingDetailVideoGtmEvent", function() { return ga4ListingDetailVideoGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectCompanyInfoGa4Event", function() { return projectCompanyInfoGa4Event; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kqSB");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("joZL");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_convert_to_url__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("I5Nt");
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_id_creator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _handleGA4UndefinedValues__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9oOR");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var getSearchId = function getSearchId() {
  var storage = JSON.parse(localStorage.getItem('EjGtmId'));
  var searchId = '0';

  if (storage.lastviewed !== null) {
    searchId = storage[storage.lastviewed];
  } else if (storage.camefromdetail !== null) {
    searchId = storage.camefromdetail;
  }

  return searchId;
};
/*
 Listing detail Initial Event
 */


var listingDetailInitialGTMEvent = function listingDetailInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};

var getItemType = function getItemType(listing) {
  var _isTradeType$, _isCategory$, _isEstaType$;

  var itemType = [];
  var dataLayer = (listing === null || listing === void 0 ? void 0 : listing.gtmDataLayer) || (listing === null || listing === void 0 ? void 0 : listing.gtmDataLayers);
  var isTradeType = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.filter(function (item) {
    return item.key === 'ilan_kategori';
  });
  var isCategory = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.filter(function (item) {
    return item.key === 'ilan_tur';
  });
  var isEstaType = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.filter(function (item) {
    return item.key === 'kategori_3';
  });
  itemType.push((_isTradeType$ = isTradeType[0]) === null || _isTradeType$ === void 0 ? void 0 : _isTradeType$.value.definition);
  itemType.push((_isCategory$ = isCategory[0]) === null || _isCategory$ === void 0 ? void 0 : _isCategory$.value.definition);
  itemType.push((_isEstaType$ = isEstaType[0]) === null || _isEstaType$ === void 0 ? void 0 : _isEstaType$.value.definition);
  return itemType;
};

var getPriceForProjects = function getPriceForProjects(item) {
  var _item$price, _item$price2, _item$price3, _item$price4, _item$price5, _item$price6, _item$price6$startPri, _item$price7, _item$price7$startPri;

  var isPriceVisibility = item.priceVisibility ? item.priceVisibility : (_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.priceVisibility;
  var itemMinPrice = (item === null || item === void 0 ? void 0 : (_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : _item$price2.min) || (item === null || item === void 0 ? void 0 : (_item$price3 = item.price) === null || _item$price3 === void 0 ? void 0 : _item$price3.minPrice);
  var itemMaxPrice = (item === null || item === void 0 ? void 0 : (_item$price4 = item.price) === null || _item$price4 === void 0 ? void 0 : _item$price4.max) || (item === null || item === void 0 ? void 0 : (_item$price5 = item.price) === null || _item$price5 === void 0 ? void 0 : _item$price5.maxPrice);
  var data = '0.00';

  switch (isPriceVisibility) {
    case 'STARTCOUNT':
      data = isPriceVisibility ? "".concat(item === null || item === void 0 ? void 0 : (_item$price6 = item.price) === null || _item$price6 === void 0 ? void 0 : (_item$price6$startPri = _item$price6.startPrice) === null || _item$price6$startPri === void 0 ? void 0 : _item$price6$startPri.toFixed(2)) : "".concat(parseInt((_item$price7 = item.price) === null || _item$price7 === void 0 ? void 0 : (_item$price7$startPri = _item$price7.startPrice) === null || _item$price7$startPri === void 0 ? void 0 : _item$price7$startPri.split('.').join(''), 10).toFixed(2));
      break;

    case 'RANGE':
      data = isPriceVisibility ? "".concat(itemMinPrice.toFixed(2), " - ").concat(itemMaxPrice.toFixed(2)) : "".concat(parseInt(itemMinPrice.split('.').join(''), 10).toFixed(2), " - ").concat(parseInt(itemMaxPrice.split('.').join(''), 10).toFixed(2));
      break;

    case 'ASK':
      data = '0.00';
      break;

    default:
      break;
  }

  if (item.salesStatus === 'FINISHED') {
    data = '0.00';
  }

  return data;
};

var totalPosition = function totalPosition(pageNumber, itemIndex, label) {
  var totalPage = pageNumber === 0 ? 1 : pageNumber;
  var postPerPage = (pageNumber - 1) * (label ? 30 : 28);
  var position = totalPage === 1 ? itemIndex + 1 : postPerPage + itemIndex + 1;
  return position;
};
/* 
When clicking look at phone in listing detail
*/


var listingDetailShowPhoneGtmEvent = function listingDetailShowPhoneGtmEvent(listing, widgetName) {
  var _listing$location, _listing$location$cit, _listing$location2, _listing$location2$di, _listing$location3, _listing$location3$to, _listing$priceDetail, _listing$priceDetail$;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: "ilan-detay/".concat(widgetName),
    ecommerce: {
      purchase: {
        actionField: {
          list: 'ilan-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'telefon-et',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: getItemType(listing)[0],
          category: "".concat(getItemType(listing)[1], "/").concat(getItemType(listing)[2], "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location = listing.location) === null || _listing$location === void 0 ? void 0 : (_listing$location$cit = _listing$location.city) === null || _listing$location$cit === void 0 ? void 0 : _listing$location$cit.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location2 = listing.location) === null || _listing$location2 === void 0 ? void 0 : (_listing$location2$di = _listing$location2.district) === null || _listing$location2$di === void 0 ? void 0 : _listing$location2$di.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location3 = listing.location) === null || _listing$location3 === void 0 ? void 0 : (_listing$location3$to = _listing$location3.town) === null || _listing$location3$to === void 0 ? void 0 : _listing$location3$to.name)),
          position: 0,
          quantity: 1,
          dimension13: getSearchId(),
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail = listing.priceDetail) === null || _listing$priceDetail === void 0 ? void 0 : (_listing$priceDetail$ = _listing$priceDetail.price) === null || _listing$priceDetail$ === void 0 ? void 0 : _listing$priceDetail$.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
  when listing detail similar listings list viewed
*/

var listingDetailSimilarListingsGTMEvent = function listingDetailSimilarListingsGTMEvent(listings) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'ilan-detay/benzer-ilanlar',
    ecommerce: {
      impressions: listings.map(function (item, index) {
        var _item$location, _item$location2, _item$location3, _JSON$parse, _item$price8, _item$price8$value;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.tradeType),
          list: 'ilan-detay/benzer-ilanlar',
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location = item.location) === null || _item$location === void 0 ? void 0 : _item$location.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location2 = item.location) === null || _item$location2 === void 0 ? void 0 : _item$location2.districtName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location3 = item.location) === null || _item$location3 === void 0 ? void 0 : _item$location3.townName)),
          position: index + 1,
          dimension13: (_JSON$parse = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.listingdetail,
          dimension40: item.firstPublishedAt,
          dimension41: ((_item$price8 = item.price) === null || _item$price8 === void 0 ? void 0 : (_item$price8$value = _item$price8.value) === null || _item$price8$value === void 0 ? void 0 : _item$price8$value.toFixed(2)) || '0.00'
        };
      })
    }
  });
};
/* 
When clicking similar list item in listing detail
*/

var listingDetailClickSimilarItemGtmEvent = function listingDetailClickSimilarItemGtmEvent(listingItem, itemIndex, label) {
  var _listingItem$location, _listingItem$location2, _listingItem$location3, _JSON$parse2, _listingItem$price, _listingItem$price$va;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: 'ilan-detay/benzer-ilanlar'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.tradeType),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location = listingItem.location) === null || _listingItem$location === void 0 ? void 0 : _listingItem$location.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location2 = listingItem.location) === null || _listingItem$location2 === void 0 ? void 0 : _listingItem$location2.districtName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location3 = listingItem.location) === null || _listingItem$location3 === void 0 ? void 0 : _listingItem$location3.townName)),
          position: itemIndex,
          dimension13: (_JSON$parse2 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.listingdetail,
          dimension40: listingItem.firstPublishedAt,
          dimension41: (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$price = listingItem.price) === null || _listingItem$price === void 0 ? void 0 : (_listingItem$price$va = _listingItem$price.value) === null || _listingItem$price$va === void 0 ? void 0 : _listingItem$price$va.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/* 
When clicking similar list item in listing detail
*/

var listingDetailClickOtherItemGtmEvent = function listingDetailClickOtherItemGtmEvent(listingItem, itemIndex, label) {
  var _listingItem$location4, _listingItem$location5, _listingItem$location6, _JSON$parse3, _listingItem$price2, _listingItem$price2$v;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: 'ilan-detay/diger-ilanlar'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.tradeType),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location4 = listingItem.location) === null || _listingItem$location4 === void 0 ? void 0 : _listingItem$location4.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location5 = listingItem.location) === null || _listingItem$location5 === void 0 ? void 0 : _listingItem$location5.districtName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location6 = listingItem.location) === null || _listingItem$location6 === void 0 ? void 0 : _listingItem$location6.townName)),
          position: itemIndex,
          dimension13: (_JSON$parse3 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.listingdetail,
          dimension40: listingItem.firstPublishedAt,
          dimension41: (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$price2 = listingItem.price) === null || _listingItem$price2 === void 0 ? void 0 : (_listingItem$price2$v = _listingItem$price2.value) === null || _listingItem$price2$v === void 0 ? void 0 : _listingItem$price2$v.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
 When listing Detail releated similar viewed
 */

var listingDetailOtherListViewed = function listingDetailOtherListViewed(listing, count) {
  var list = count ? listing.filter(function (item, index) {
    return index === count;
  }) : listing;
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'ilan-detay/diger-ilanlar',
    ecommerce: {
      impressions: list.map(function (item, index) {
        var _item$location4, _item$location5, _item$location6, _JSON$parse4, _item$price9, _item$price9$value;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
          brand: 'ilan',
          list: 'ilan-detay/diger-ilanlar',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.tradeType),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location4 = item.location) === null || _item$location4 === void 0 ? void 0 : _item$location4.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location5 = item.location) === null || _item$location5 === void 0 ? void 0 : _item$location5.districtName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location6 = item.location) === null || _item$location6 === void 0 ? void 0 : _item$location6.townName)),
          position: count ? count + 1 : index + 1,
          dimension13: (_JSON$parse4 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse4 === void 0 ? void 0 : _JSON$parse4.listingdetail,
          dimension40: item.firstPublishedAt,
          dimension41: (item === null || item === void 0 ? void 0 : (_item$price9 = item.price) === null || _item$price9 === void 0 ? void 0 : (_item$price9$value = _item$price9.value) === null || _item$price9$value === void 0 ? void 0 : _item$price9$value.toFixed(2)) || '0.00'
        };
      })
    }
  });
};
/*
when click add to favorite on listing detail
*/

var listingDetailAddFavoriteGtmEvent = function listingDetailAddFavoriteGtmEvent(listingItem) {
  var _listingItem$location7, _listingItem$location8, _listingItem$location9, _listingItem$location10, _listingItem$location11, _listingItem$location12, _listingItem$priceDet, _listingItem$priceDet2;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'ilan-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'ilan-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'favoriler',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.title.trim()),
          brand: 'ilan',
          variant: getItemType(listingItem)[0],
          category: "".concat(getItemType(listingItem)[1], "/").concat(getItemType(listingItem)[2], "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location7 = listingItem.location) === null || _listingItem$location7 === void 0 ? void 0 : (_listingItem$location8 = _listingItem$location7.city) === null || _listingItem$location8 === void 0 ? void 0 : _listingItem$location8.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location9 = listingItem.location) === null || _listingItem$location9 === void 0 ? void 0 : (_listingItem$location10 = _listingItem$location9.district) === null || _listingItem$location10 === void 0 ? void 0 : _listingItem$location10.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location11 = listingItem.location) === null || _listingItem$location11 === void 0 ? void 0 : (_listingItem$location12 = _listingItem$location11.town) === null || _listingItem$location12 === void 0 ? void 0 : _listingItem$location12.name)),
          position: 0,
          quantity: 1,
          dimension13: getSearchId(),
          dimension40: listingItem.createdAt,
          dimension41: (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$priceDet = listingItem.priceDetail) === null || _listingItem$priceDet === void 0 ? void 0 : (_listingItem$priceDet2 = _listingItem$priceDet.price) === null || _listingItem$priceDet2 === void 0 ? void 0 : _listingItem$priceDet2.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click share on listing detail
*/

var listingDetailShareGtmEvent = function listingDetailShareGtmEvent(listing) {
  var _listing$location4, _listing$location4$ci, _listing$location5, _listing$location5$di, _listing$location6, _listing$location6$to, _listing$priceDetail2, _listing$priceDetail3;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'ilan-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'ilan-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'paylas',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: getItemType(listing)[0],
          category: "".concat(getItemType(listing)[1], "/").concat(getItemType(listing)[2], "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location4 = listing.location) === null || _listing$location4 === void 0 ? void 0 : (_listing$location4$ci = _listing$location4.city) === null || _listing$location4$ci === void 0 ? void 0 : _listing$location4$ci.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location5 = listing.location) === null || _listing$location5 === void 0 ? void 0 : (_listing$location5$di = _listing$location5.district) === null || _listing$location5$di === void 0 ? void 0 : _listing$location5$di.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location6 = listing.location) === null || _listing$location6 === void 0 ? void 0 : (_listing$location6$to = _listing$location6.town) === null || _listing$location6$to === void 0 ? void 0 : _listing$location6$to.name)),
          position: 0,
          quantity: 1,
          dimension13: getSearchId(),
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail2 = listing.priceDetail) === null || _listing$priceDetail2 === void 0 ? void 0 : (_listing$priceDetail3 = _listing$priceDetail2.price) === null || _listing$priceDetail3 === void 0 ? void 0 : _listing$priceDetail3.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click send message buton on listing detail
*/

var listingDetailSendMessageGtmEvent = function listingDetailSendMessageGtmEvent(listing) {
  var _listing$location7, _listing$location7$ci, _listing$location8, _listing$location8$di, _listing$location9, _listing$location9$to, _listing$priceDetail4, _listing$priceDetail5;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'ilan-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'ilan-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'mesaj-gonder',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: getItemType(listing)[0],
          category: "".concat(getItemType(listing)[1], "/").concat(getItemType(listing)[2], "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location7 = listing.location) === null || _listing$location7 === void 0 ? void 0 : (_listing$location7$ci = _listing$location7.city) === null || _listing$location7$ci === void 0 ? void 0 : _listing$location7$ci.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location8 = listing.location) === null || _listing$location8 === void 0 ? void 0 : (_listing$location8$di = _listing$location8.district) === null || _listing$location8$di === void 0 ? void 0 : _listing$location8$di.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location9 = listing.location) === null || _listing$location9 === void 0 ? void 0 : (_listing$location9$to = _listing$location9.town) === null || _listing$location9$to === void 0 ? void 0 : _listing$location9$to.name)),
          position: 0,
          quantity: 1,
          dimension13: getSearchId(),
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail4 = listing.priceDetail) === null || _listing$priceDetail4 === void 0 ? void 0 : (_listing$priceDetail5 = _listing$priceDetail4.price) === null || _listing$priceDetail5 === void 0 ? void 0 : _listing$priceDetail5.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
 Project Initial Event
 */

var projectDetailInitialGTMEvent = function projectDetailInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
when project detail viewed 
*/

var projectDetailViewedGTMEvent = function projectDetailViewedGTMEvent(pageResponse) {
  var _isproject$locationIn, _isproject$locationIn2, _isproject$tradeType, _isproject$category$, _isproject$estateType, _isproject$locationIn3, _isproject$locationIn4, _isproject$category, _isproject$estateType2, _isproject$locationIn5, _isproject$locationIn6, _isproject$locationIn7, _isproject$locationIn8;

  var isproject = pageResponse === null || pageResponse === void 0 ? void 0 : pageResponse.projectDetail;
  var isDistrictName = (_isproject$locationIn = isproject.locationInfo) === null || _isproject$locationIn === void 0 ? void 0 : (_isproject$locationIn2 = _isproject$locationIn.district) === null || _isproject$locationIn2 === void 0 ? void 0 : _isproject$locationIn2.name;
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'detail',
    event_label: 'proje-detay',
    ecommerce: {
      detail: {
        products: [{
          id: "".concat(isproject.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(isproject.name.trim()),
          brand: 'proje',
          variant: (_isproject$tradeType = isproject.tradeType) === null || _isproject$tradeType === void 0 ? void 0 : _isproject$tradeType.slug,
          category: isproject.category[1] ? "".concat(isproject.category[0].slug, "-").concat((_isproject$category$ = isproject.category[1]) === null || _isproject$category$ === void 0 ? void 0 : _isproject$category$.slug, "/").concat((_isproject$estateType = isproject.estateType) === null || _isproject$estateType === void 0 ? void 0 : _isproject$estateType.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_isproject$locationIn3 = isproject.locationInfo) === null || _isproject$locationIn3 === void 0 ? void 0 : (_isproject$locationIn4 = _isproject$locationIn3.city) === null || _isproject$locationIn4 === void 0 ? void 0 : _isproject$locationIn4.slug), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(isDistrictName), "/") : "".concat((_isproject$category = isproject.category) === null || _isproject$category === void 0 ? void 0 : _isproject$category.slug, "/").concat(isproject === null || isproject === void 0 ? void 0 : (_isproject$estateType2 = isproject.estateType) === null || _isproject$estateType2 === void 0 ? void 0 : _isproject$estateType2.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_isproject$locationIn5 = isproject.locationInfo) === null || _isproject$locationIn5 === void 0 ? void 0 : (_isproject$locationIn6 = _isproject$locationIn5.city) === null || _isproject$locationIn6 === void 0 ? void 0 : _isproject$locationIn6.slug), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_isproject$locationIn7 = isproject.locationInfo) === null || _isproject$locationIn7 === void 0 ? void 0 : (_isproject$locationIn8 = _isproject$locationIn7.district) === null || _isproject$locationIn8 === void 0 ? void 0 : _isproject$locationIn8.name), "/"),
          position: 0,
          dimension13: getSearchId(),
          dimension40: isproject.createdAt,
          dimension41: getPriceForProjects(isproject)
        }]
      }
    }
  });
};
var projectDetailViewedGA4Event = function projectDetailViewedGA4Event(ga4DataLayer, searchId) {
  var formattedDataLayer = Object(_handleGA4UndefinedValues__WEBPACK_IMPORTED_MODULE_4__[/* handleGA4UndefinedValues */ "a"])(ga4DataLayer);
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])(_objectSpread({
    platform: 'web-desktop',
    search_id: searchId
  }, formattedDataLayer));
};
/*
when project detail click phone 
*/

var projectDetailShowPhoneGtmEvent = function projectDetailShowPhoneGtmEvent(project) {
  var _project$tradeType, _project$estateType, _project$locationInfo, _project$locationInfo2, _project$locationInfo3, _project$locationInfo4;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'proje-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'proje-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'telefon-et',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(project.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(project.name.trim()),
          brand: 'proje',
          variant: (_project$tradeType = project.tradeType) === null || _project$tradeType === void 0 ? void 0 : _project$tradeType.slug,
          category: "".concat(project.category.slug, "/").concat(project === null || project === void 0 ? void 0 : (_project$estateType = project.estateType) === null || _project$estateType === void 0 ? void 0 : _project$estateType.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$locationInfo = project.locationInfo) === null || _project$locationInfo === void 0 ? void 0 : (_project$locationInfo2 = _project$locationInfo.city) === null || _project$locationInfo2 === void 0 ? void 0 : _project$locationInfo2.slug), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$locationInfo3 = project.locationInfo) === null || _project$locationInfo3 === void 0 ? void 0 : (_project$locationInfo4 = _project$locationInfo3.district) === null || _project$locationInfo4 === void 0 ? void 0 : _project$locationInfo4.name), "/"),
          position: 0,
          quantity: 1,
          dimension13: getSearchId(),
          dimension40: project.createdAt,
          dimension41: getPriceForProjects(project)
        }]
      }
    }
  });
};
/*
When the project detail form is submitted
*/

var projectDetailFormSubmitGTMEvent = function projectDetailFormSubmitGTMEvent(project) {
  var _project$tradeType2, _project$category, _project$estateType2, _project$city, _project$district;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'proje-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'proje-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'form',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(project.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(project.name.trim()),
          brand: 'proje',
          variant: (_project$tradeType2 = project.tradeType) === null || _project$tradeType2 === void 0 ? void 0 : _project$tradeType2.slug,
          category: "".concat(project === null || project === void 0 ? void 0 : (_project$category = project.category) === null || _project$category === void 0 ? void 0 : _project$category.slug, "/").concat(project === null || project === void 0 ? void 0 : (_project$estateType2 = project.estateType) === null || _project$estateType2 === void 0 ? void 0 : _project$estateType2.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(project === null || project === void 0 ? void 0 : (_project$city = project.city) === null || _project$city === void 0 ? void 0 : _project$city.slug), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(project === null || project === void 0 ? void 0 : (_project$district = project.district) === null || _project$district === void 0 ? void 0 : _project$district.name), "/"),
          position: 0,
          quantity: 1,
          dimension13: getSearchId(),
          dimension40: project.createdAt,
          dimension41: getPriceForProjects(project)
        }]
      }
    }
  });
};
/*
when listing title viewed after listing detail viewed
*/

var listingDetailListingViewedGTMEvent = function listingDetailListingViewedGTMEvent(listing) {
  var _listing$location10, _listing$location10$c, _listing$location11, _listing$location11$d, _listing$location12, _listing$location12$t, _listing$priceDetail6, _listing$priceDetail7;

  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'detail',
    event_label: 'ilan-detay',
    ecommerce: {
      detail: {
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: getItemType(listing)[0],
          category: "".concat(getItemType(listing)[1], "/").concat(getItemType(listing)[2], "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location10 = listing.location) === null || _listing$location10 === void 0 ? void 0 : (_listing$location10$c = _listing$location10.city) === null || _listing$location10$c === void 0 ? void 0 : _listing$location10$c.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location11 = listing.location) === null || _listing$location11 === void 0 ? void 0 : (_listing$location11$d = _listing$location11.district) === null || _listing$location11$d === void 0 ? void 0 : _listing$location11$d.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location12 = listing.location) === null || _listing$location12 === void 0 ? void 0 : (_listing$location12$t = _listing$location12.town) === null || _listing$location12$t === void 0 ? void 0 : _listing$location12$t.name)),
          position: 0,
          dimension13: getSearchId(),
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail6 = listing.priceDetail) === null || _listing$priceDetail6 === void 0 ? void 0 : (_listing$priceDetail7 = _listing$priceDetail6.price) === null || _listing$priceDetail7 === void 0 ? void 0 : _listing$priceDetail7.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when project detail releated projects clicked 
*/

var handleProjectDetailReleatedProjectsGTMEvent = function handleProjectDetailReleatedProjectsGTMEvent(event, project, itemIndex, label) {
  var _project$estateType3, _project$locationInfo5, _project$locationInfo6, _JSON$parse5;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: 'proje-detay/bolgedeki-projeler'
        },
        products: [{
          id: "".concat(project.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(project.name.trim()),
          brand: 'proje',
          variant: project.tradeType.slug,
          category: "".concat(project.category.slug, "/").concat(project === null || project === void 0 ? void 0 : (_project$estateType3 = project.estateType) === null || _project$estateType3 === void 0 ? void 0 : _project$estateType3.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$locationInfo5 = project.locationInfo) === null || _project$locationInfo5 === void 0 ? void 0 : _project$locationInfo5.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$locationInfo6 = project.locationInfo) === null || _project$locationInfo6 === void 0 ? void 0 : _project$locationInfo6.districtName), "/"),
          position: itemIndex + 1,
          dimension13: (_JSON$parse5 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse5 === void 0 ? void 0 : _JSON$parse5.projectdetail,
          dimension40: project.createdAt,
          dimension41: getPriceForProjects(project)
        }]
      }
    }
  });
};
/*
 Agent Page Detail Initial Event
 */

var agentPageDetailInitialGTMEvent = function agentPageDetailInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
 When Agent Page Detail listing viewed
 */

var agentPageDetailListingViewed = function agentPageDetailListingViewed(listing, positions, pageNumber) {
  var postPerPage = pageNumber === 0 ? 1 : 28;
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'emlak-ofisi-detay',
    ecommerce: {
      impressions: listing.map(function (item, index) {
        var _item$location7, _item$location7$city, _item$location8, _item$location8$distr, _item$location9, _item$location9$town, _JSON$parse6, _item$priceDetail, _item$priceDetail$pri;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.tradeTypeName),
          list: 'emlak-ofisi-detay',
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location7 = item.location) === null || _item$location7 === void 0 ? void 0 : (_item$location7$city = _item$location7.city) === null || _item$location7$city === void 0 ? void 0 : _item$location7$city.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location8 = item.location) === null || _item$location8 === void 0 ? void 0 : (_item$location8$distr = _item$location8.district) === null || _item$location8$distr === void 0 ? void 0 : _item$location8$distr.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location9 = item.location) === null || _item$location9 === void 0 ? void 0 : (_item$location9$town = _item$location9.town) === null || _item$location9$town === void 0 ? void 0 : _item$location9$town.name)),
          position: postPerPage * (pageNumber === 0 ? pageNumber : pageNumber - 1) + (parseInt(positions[index], 10) + 1),
          dimension13: (_JSON$parse6 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse6 === void 0 ? void 0 : _JSON$parse6.agentdetail,
          dimension40: item.createdAt,
          dimension41: (_item$priceDetail = item.priceDetail) === null || _item$priceDetail === void 0 ? void 0 : (_item$priceDetail$pri = _item$priceDetail.price) === null || _item$priceDetail$pri === void 0 ? void 0 : _item$priceDetail$pri.toFixed(2)
        };
      })
    }
  });
};
/* 
when real estate agent detail postings are clicked
*/

var handleAgentDetailGTMEvent = function handleAgentDetailGTMEvent(event, listing, itemIndex, pageNumber, label) {
  var _listing$location13, _listing$location13$c, _listing$location14, _listing$location14$d, _listing$location15, _listing$location15$t, _JSON$parse7, _listing$priceDetail8, _listing$priceDetail9;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: 'emlak-ofisi-detay'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.tradeTypeName),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location13 = listing.location) === null || _listing$location13 === void 0 ? void 0 : (_listing$location13$c = _listing$location13.city) === null || _listing$location13$c === void 0 ? void 0 : _listing$location13$c.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location14 = listing.location) === null || _listing$location14 === void 0 ? void 0 : (_listing$location14$d = _listing$location14.district) === null || _listing$location14$d === void 0 ? void 0 : _listing$location14$d.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location15 = listing.location) === null || _listing$location15 === void 0 ? void 0 : (_listing$location15$t = _listing$location15.town) === null || _listing$location15$t === void 0 ? void 0 : _listing$location15$t.name)),
          position: totalPosition(pageNumber, itemIndex),
          dimension13: (_JSON$parse7 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse7 === void 0 ? void 0 : _JSON$parse7.agentdetail,
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail8 = listing.priceDetail) === null || _listing$priceDetail8 === void 0 ? void 0 : (_listing$priceDetail9 = _listing$priceDetail8.price) === null || _listing$priceDetail9 === void 0 ? void 0 : _listing$priceDetail9.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click show phone on agent detail
*/

var agentDetailShowPhoneGTMEvent = function agentDetailShowPhoneGTMEvent(event, listing, itemIndex, pageNumber, affiliation) {
  var _listing$location16, _listing$location16$c, _listing$location17, _listing$location17$d, _listing$location18, _listing$location18$t, _JSON$parse8, _listing$priceDetail10, _listing$priceDetail11;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'emlak-ofisi-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'emlak-ofisi-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: affiliation,
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.tradeTypeName),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location16 = listing.location) === null || _listing$location16 === void 0 ? void 0 : (_listing$location16$c = _listing$location16.city) === null || _listing$location16$c === void 0 ? void 0 : _listing$location16$c.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location17 = listing.location) === null || _listing$location17 === void 0 ? void 0 : (_listing$location17$d = _listing$location17.district) === null || _listing$location17$d === void 0 ? void 0 : _listing$location17$d.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location18 = listing.location) === null || _listing$location18 === void 0 ? void 0 : (_listing$location18$t = _listing$location18.town) === null || _listing$location18$t === void 0 ? void 0 : _listing$location18$t.name)),
          position: totalPosition(pageNumber, itemIndex),
          quantity: 1,
          dimension13: (_JSON$parse8 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse8 === void 0 ? void 0 : _JSON$parse8.agentdetail,
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail10 = listing.priceDetail) === null || _listing$priceDetail10 === void 0 ? void 0 : (_listing$priceDetail11 = _listing$priceDetail10.price) === null || _listing$priceDetail11 === void 0 ? void 0 : _listing$priceDetail11.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click add to favorite on agent detail
*/

var agentDetailAddFavoriteGTMEvent = function agentDetailAddFavoriteGTMEvent(event, listingItem, itemIndex, pageNumber) {
  var _listingItem$location13, _listingItem$location14, _listingItem$location15, _listingItem$location16, _listingItem$location17, _listingItem$location18, _JSON$parse9, _listingItem$priceDet3, _listingItem$priceDet4;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'emlak-ofisi-detay',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'emlak-ofisi-detay',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'favoriler',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.tradeTypeName),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location13 = listingItem.location) === null || _listingItem$location13 === void 0 ? void 0 : (_listingItem$location14 = _listingItem$location13.city) === null || _listingItem$location14 === void 0 ? void 0 : _listingItem$location14.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location15 = listingItem.location) === null || _listingItem$location15 === void 0 ? void 0 : (_listingItem$location16 = _listingItem$location15.district) === null || _listingItem$location16 === void 0 ? void 0 : _listingItem$location16.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location17 = listingItem.location) === null || _listingItem$location17 === void 0 ? void 0 : (_listingItem$location18 = _listingItem$location17.town) === null || _listingItem$location18 === void 0 ? void 0 : _listingItem$location18.name)),
          position: totalPosition(pageNumber, itemIndex),
          quantity: 1,
          dimension13: (_JSON$parse9 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse9 === void 0 ? void 0 : _JSON$parse9.agentdetail,
          dimension40: listingItem.createdAt,
          dimension41: (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$priceDet3 = listingItem.priceDetail) === null || _listingItem$priceDet3 === void 0 ? void 0 : (_listingItem$priceDet4 = _listingItem$priceDet3.price) === null || _listingItem$priceDet4 === void 0 ? void 0 : _listingItem$priceDet4.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
ShowCase Initial Event
 */

var showCaseInitialGTMEvent = function showCaseInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
when scrolling in the showcase
*/

var showCaseListingViewedGTMEvent = function showCaseListingViewedGTMEvent(listing, positions, pageNumber) {
  var postPerPage = pageNumber === 0 ? 1 : 30;
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'vitrin',
    ecommerce: {
      impressions: listing.map(function (item, index) {
        var _item$properties, _item$properties$TRAD, _item$properties2, _item$properties$CITY, _item$properties$DIST, _item$properties$TOWN, _JSON$parse10, _item$price_order;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.tr.trim()),
          brand: 'ilan',
          variant: (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : (_item$properties$TRAD = _item$properties.TRADE_TYPE) === null || _item$properties$TRAD === void 0 ? void 0 : _item$properties$TRAD.slug,
          list: 'vitrin',
          category: "".concat(item.properties.CATEGORY.slug, "/").concat((_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2.SUBCATEGORY.slug, "/").concat((_item$properties$CITY = item.properties.CITY) === null || _item$properties$CITY === void 0 ? void 0 : _item$properties$CITY.slug, "/").concat((_item$properties$DIST = item.properties.DISTRICT) === null || _item$properties$DIST === void 0 ? void 0 : _item$properties$DIST.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$properties$TOWN = item.properties.TOWN) === null || _item$properties$TOWN === void 0 ? void 0 : _item$properties$TOWN.name)),
          position: postPerPage * (pageNumber - 1) + (parseInt(positions[index], 10) + 1),
          dimension13: (_JSON$parse10 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse10 === void 0 ? void 0 : _JSON$parse10.showcase,
          dimension40: item.created_at,
          dimension41: ((_item$price_order = item.price_order) === null || _item$price_order === void 0 ? void 0 : _item$price_order.toFixed(2)) || '0.00'
        };
      })
    }
  });
};
/*
when clicked listing in the showcase
*/

var handleShowcaseListingGTMEvent = function handleShowcaseListingGTMEvent(event, listing, itemIndex, pageNumber) {
  var _listing$properties, _listing$properties$T, _listing$properties2, _listing$properties$C, _listing$properties$D, _listing$properties$T2, _JSON$parse11, _listing$price_order;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: 'ilan-gorsel',
    ecommerce: {
      click: {
        actionField: {
          list: 'vitrin'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.tr.trim()),
          brand: 'ilan',
          variant: (_listing$properties = listing.properties) === null || _listing$properties === void 0 ? void 0 : (_listing$properties$T = _listing$properties.TRADE_TYPE) === null || _listing$properties$T === void 0 ? void 0 : _listing$properties$T.slug,
          category: "".concat(listing.properties.CATEGORY.slug, "/").concat((_listing$properties2 = listing.properties) === null || _listing$properties2 === void 0 ? void 0 : _listing$properties2.SUBCATEGORY.slug, "/").concat((_listing$properties$C = listing.properties.CITY) === null || _listing$properties$C === void 0 ? void 0 : _listing$properties$C.slug, "/").concat((_listing$properties$D = listing.properties.DISTRICT) === null || _listing$properties$D === void 0 ? void 0 : _listing$properties$D.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$properties$T2 = listing.properties.TOWN) === null || _listing$properties$T2 === void 0 ? void 0 : _listing$properties$T2.name)),
          position: totalPosition(pageNumber, itemIndex, 'detail'),
          dimension13: (_JSON$parse11 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse11 === void 0 ? void 0 : _JSON$parse11.showcase,
          dimension40: listing.created_at,
          dimension41: ((_listing$price_order = listing.price_order) === null || _listing$price_order === void 0 ? void 0 : _listing$price_order.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click show phone on showcase
*/

var showcaseShowPhoneGTMEvent = function showcaseShowPhoneGTMEvent(event, listing, itemIndex, pageNumber) {
  var _listing$properties3, _listing$properties3$, _listing$properties4, _listing$properties$C2, _listing$properties$D2, _listing$properties$T3, _JSON$parse12, _listing$price_order2;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'vitrin',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'vitrin',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'telefon-et',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.tr.trim()),
          brand: 'ilan',
          variant: (_listing$properties3 = listing.properties) === null || _listing$properties3 === void 0 ? void 0 : (_listing$properties3$ = _listing$properties3.TRADE_TYPE) === null || _listing$properties3$ === void 0 ? void 0 : _listing$properties3$.slug,
          category: "".concat(listing.properties.CATEGORY.slug, "/").concat((_listing$properties4 = listing.properties) === null || _listing$properties4 === void 0 ? void 0 : _listing$properties4.SUBCATEGORY.slug, "/").concat((_listing$properties$C2 = listing.properties.CITY) === null || _listing$properties$C2 === void 0 ? void 0 : _listing$properties$C2.slug, "/").concat((_listing$properties$D2 = listing.properties.DISTRICT) === null || _listing$properties$D2 === void 0 ? void 0 : _listing$properties$D2.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$properties$T3 = listing.properties.TOWN) === null || _listing$properties$T3 === void 0 ? void 0 : _listing$properties$T3.name)),
          position: totalPosition(pageNumber, itemIndex, 'showPhone'),
          quantity: 1,
          dimension13: (_JSON$parse12 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse12 === void 0 ? void 0 : _JSON$parse12.showcase,
          dimension40: listing.created_at,
          dimension41: ((_listing$price_order2 = listing.price_order) === null || _listing$price_order2 === void 0 ? void 0 : _listing$price_order2.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click favorite button on showcase
*/

var showcaseAddFavoriteGTMEvent = function showcaseAddFavoriteGTMEvent(event, listingItem, itemIndex, pageNumber) {
  var _listingItem$properti, _listingItem$properti2, _listingItem$properti3, _listingItem$properti4, _listingItem$properti5, _listingItem$properti6, _JSON$parse13, _listingItem$price_or;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'vitrin',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'vitrin',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'favoriler',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.title.tr.trim()),
          brand: 'ilan',
          variant: (_listingItem$properti = listingItem.properties) === null || _listingItem$properti === void 0 ? void 0 : (_listingItem$properti2 = _listingItem$properti.TRADE_TYPE) === null || _listingItem$properti2 === void 0 ? void 0 : _listingItem$properti2.slug,
          category: "".concat(listingItem.properties.CATEGORY.slug, "/").concat((_listingItem$properti3 = listingItem.properties) === null || _listingItem$properti3 === void 0 ? void 0 : _listingItem$properti3.SUBCATEGORY.slug, "/").concat((_listingItem$properti4 = listingItem.properties.CITY) === null || _listingItem$properti4 === void 0 ? void 0 : _listingItem$properti4.slug, "/").concat((_listingItem$properti5 = listingItem.properties.DISTRICT) === null || _listingItem$properti5 === void 0 ? void 0 : _listingItem$properti5.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$properti6 = listingItem.properties.TOWN) === null || _listingItem$properti6 === void 0 ? void 0 : _listingItem$properti6.name)),
          position: totalPosition(pageNumber, itemIndex, 'favorite'),
          quantity: 1,
          dimension13: (_JSON$parse13 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse13 === void 0 ? void 0 : _JSON$parse13.showcase,
          dimension40: listingItem.created_at,
          dimension41: ((_listingItem$price_or = listingItem.price_order) === null || _listingItem$price_or === void 0 ? void 0 : _listingItem$price_or.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
Compare Initial Event
 */

var compareInitialGTMEvent = function compareInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
when compare page detail viewed 
*/

var compareViewedGTMEvent = function compareViewedGTMEvent(compareListings) {
  if ((compareListings === null || compareListings === void 0 ? void 0 : compareListings.length) > 0) {
    Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
      ecommerce: null
    });
    Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
      event: 'uaEcEvent',
      event_category: 'enhanced-ecommerce',
      event_action: 'impression',
      event_label: 'karsilastir',
      ecommerce: {
        impressions: compareListings.map(function (item, index) {
          var _item$location10, _item$location10$city, _item$location11, _item$location11$dist, _item$location12, _item$location12$town, _JSON$parse14, _item$priceDetail2;

          return {
            id: "".concat(item.id),
            name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
            brand: 'ilan',
            variant: getItemType(item)[0],
            list: 'karsilastir',
            category: "".concat(getItemType(item)[1], "/").concat(getItemType(item)[2], "/").concat((_item$location10 = item.location) === null || _item$location10 === void 0 ? void 0 : (_item$location10$city = _item$location10.city) === null || _item$location10$city === void 0 ? void 0 : _item$location10$city.slug, "/").concat((_item$location11 = item.location) === null || _item$location11 === void 0 ? void 0 : (_item$location11$dist = _item$location11.district) === null || _item$location11$dist === void 0 ? void 0 : _item$location11$dist.slug, "/").concat((_item$location12 = item.location) === null || _item$location12 === void 0 ? void 0 : (_item$location12$town = _item$location12.town) === null || _item$location12$town === void 0 ? void 0 : _item$location12$town.slug),
            position: index + 1,
            dimension13: (_JSON$parse14 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse14 === void 0 ? void 0 : _JSON$parse14.compare,
            dimension40: item.createdAt,
            dimension41: ((_item$priceDetail2 = item.priceDetail) === null || _item$priceDetail2 === void 0 ? void 0 : _item$priceDetail2.price.toFixed(2)) || '0.00'
          };
        })
      }
    });
  }
};
/*
when click show phone and share button on compare page
*/

var compareShowPhoneAndShareGTMEvent = function compareShowPhoneAndShareGTMEvent(event, listing, itemIndex, label) {
  var _listing$title, _listing$location19, _listing$location19$c, _listing$location20, _listing$location20$d, _listing$location21, _listing$location21$t, _JSON$parse15, _listing$priceDetail12;

  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'karsilastir',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'karsilastir',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: label,
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$title = listing.title) === null || _listing$title === void 0 ? void 0 : _listing$title.trim()),
          brand: 'ilan',
          variant: getItemType(listing)[0],
          category: "".concat(getItemType(listing)[1], "/").concat(getItemType(listing)[2], "/").concat((_listing$location19 = listing.location) === null || _listing$location19 === void 0 ? void 0 : (_listing$location19$c = _listing$location19.city) === null || _listing$location19$c === void 0 ? void 0 : _listing$location19$c.slug, "/").concat((_listing$location20 = listing.location) === null || _listing$location20 === void 0 ? void 0 : (_listing$location20$d = _listing$location20.district) === null || _listing$location20$d === void 0 ? void 0 : _listing$location20$d.slug, "/").concat((_listing$location21 = listing.location) === null || _listing$location21 === void 0 ? void 0 : (_listing$location21$t = _listing$location21.town) === null || _listing$location21$t === void 0 ? void 0 : _listing$location21$t.slug),
          position: itemIndex + 1,
          quantity: 1,
          dimension13: (_JSON$parse15 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse15 === void 0 ? void 0 : _JSON$parse15.compare,
          dimension40: listing.createdAt,
          dimension41: ((_listing$priceDetail12 = listing.priceDetail) === null || _listing$priceDetail12 === void 0 ? void 0 : _listing$priceDetail12.price.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
 When project Detail releated projects viewed
 */

var projectDetailReleatedProjectViewed = function projectDetailReleatedProjectViewed(listing, positions) {
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'proje-detay/bolgedeki-projeler',
    ecommerce: {
      impressions: listing.map(function (item, index) {
        var _item$tradeType, _item$category, _item$estateType, _item$locationInfo, _item$locationInfo2, _JSON$parse16;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.name.trim()),
          brand: 'proje',
          variant: (_item$tradeType = item.tradeType) === null || _item$tradeType === void 0 ? void 0 : _item$tradeType.slug,
          list: 'proje-detay/bolgedeki-projeler',
          category: "".concat((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.slug, "/").concat((_item$estateType = item.estateType) === null || _item$estateType === void 0 ? void 0 : _item$estateType.slug, "/").concat((_item$locationInfo = item.locationInfo) === null || _item$locationInfo === void 0 ? void 0 : _item$locationInfo.cityName, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$locationInfo2 = item.locationInfo) === null || _item$locationInfo2 === void 0 ? void 0 : _item$locationInfo2.districtName), "/"),
          position: parseInt(positions[index], 10) + 1,
          dimension13: (_JSON$parse16 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse16 === void 0 ? void 0 : _JSON$parse16.projectdetail,
          dimension40: item.createdAt,
          dimension41: getPriceForProjects(item)
        };
      })
    }
  });
};
/*
when scrolling in favorite list detail
*/

var favoriteListViewedGTMEvent = function favoriteListViewedGTMEvent(listing, positions) {
  var searchId = JSON.parse(localStorage.getItem('EjGtmId'));
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'favori-listesi',
    ecommerce: {
      impressions: listing === null || listing === void 0 ? void 0 : listing.map(function (item, index) {
        var _item$location13, _item$location14, _item$location15;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.tradeType),
          list: 'favori-listesi',
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location13 = item.location) === null || _item$location13 === void 0 ? void 0 : _item$location13.city.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location14 = item.location) === null || _item$location14 === void 0 ? void 0 : _item$location14.district.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location15 = item.location) === null || _item$location15 === void 0 ? void 0 : _item$location15.town.name)),
          position: parseInt(positions[0], 10) + index + 1,
          dimension13: searchId.favoriteListDetail,
          dimension40: item.createdAt,
          dimension41: item.price.value.toFixed(2) || '0.00'
        };
      })
    }
  });
};
var listingDetailListingViewedGA4Event = function listingDetailListingViewedGA4Event(listing, searchId) {
  var dataLayerObject = Object(_handleGA4UndefinedValues__WEBPACK_IMPORTED_MODULE_4__[/* handleGA4UndefinedValues */ "a"])(listing);
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])(_objectSpread({
    platform: 'web-desktop',
    search_id: searchId
  }, dataLayerObject));
};
var ga4ListingDetailVideoGtmEvent = function ga4ListingDetailVideoGtmEvent(isYoutubeVideo) {
  var functionsByValue = {
    "true": 'youtube',
    "false": 'video',
    undefined: 'no'
  };
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    ilan_video: functionsByValue[isYoutubeVideo]
  });
};
var projectCompanyInfoGa4Event = function projectCompanyInfoGa4Event(params) {
  var resultId = params.resultId,
      name = params.name,
      projects = params.projects,
      pageType = params.pageType,
      itemType = params.itemType;
  Object(___WEBPACK_IMPORTED_MODULE_1__[/* GTMPushEvent */ "a"])({
    platform: 'web-desktop',
    search_id: resultId,
    page_type: pageType,
    project_company_name: name,
    item_type: itemType,
    total_item: projects === null || projects === void 0 ? void 0 : projects.length,
    design_type: 'old'
  });
};

/***/ }),

/***/ "joZL":
/***/ (function(module, exports) {

var convertToUrl = function convertToUrl(text) {
  if (!text) return '';
  var regex = /(ö|ç|ş|ı|ğ|ü)/g;
  var characters = {
    ö: 'o',
    ç: 'c',
    ş: 's',
    ı: 'i',
    ğ: 'g',
    ü: 'u'
  };
  text = text.toLocaleLowerCase('tr-TR');

  if (regex.test(text)) {
    text = text.replace(regex, function (m, key) {
      return characters[key];
    });
  }
  /* remove the special char */


  text = text.replace(/[^A-Z0-9]+/gi, '-');
  /* space to '-' */

  text = text.replace(/[\s-]+/g, '-');
  return text;
};

module.exports = convertToUrl;

/***/ }),

/***/ "kSbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ social_bar; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// EXTERNAL MODULE: ./__mock__/homeDatas.js
var homeDatas = __webpack_require__("p8IS");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/social-bar/styles.module.scss
var styles_module = __webpack_require__("JlvA");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/social-bar/social-bar.jsx
var __jsx = react_default.a.createElement;

 // eslint-disable-next-line import/no-unresolved




var social_bar_SocialBar = function SocialBar() {
  return __jsx(react_default.a.Fragment, null, __jsx("div", {
    className: styles_module_default.a.sponsorAndLogo
  }, __jsx("div", {
    className: styles_module_default.a.container
  }, __jsx("div", {
    className: styles_module_default.a.logos
  }, __jsx(lazy_image["a" /* default */], {
    src: "/static/img/logo.svg",
    placeholder: "/static/img/1px-transparent.png",
    alt: "Emlakjet",
    width: 128,
    height: 40
  })))), __jsx("div", {
    className: styles_module_default.a.socialBar
  }, __jsx("div", {
    className: styles_module_default.a.container,
    style: {
      paddingBottom: 0
    }
  }, __jsx("div", {
    className: styles_module_default.a.logos
  }, __jsx("div", {
    className: styles_module_default.a.buttonList
  }, homeDatas["d" /* socialBarIcons */].map(function (socialBarIcons) {
    var href = socialBarIcons.href,
        src = socialBarIcons.src,
        _socialBarIcons$place = socialBarIcons.placeholder,
        placeholder = _socialBarIcons$place === void 0 ? false : _socialBarIcons$place;
    return __jsx("a", {
      href: href,
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(lazy_image["a" /* default */], {
      width: 48,
      height: 49,
      src: src,
      placeholder: placeholder,
      alt: "Emlakjet"
    }));
  })), __jsx("div", {
    className: styles_module_default.a.buttonList
  }, homeDatas["c" /* socialBarApps */].map(function (socialBarApps) {
    var href = socialBarApps.href,
        src = socialBarApps.src,
        _socialBarApps$placeh = socialBarApps.placeholder,
        placeholder = _socialBarApps$placeh === void 0 ? false : _socialBarApps$placeh;
    return __jsx("a", {
      href: href,
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(lazy_image["a" /* default */], {
      width: 150,
      height: 49,
      src: src,
      placeholder: placeholder,
      alt: "Emlakjet"
    }));
  }))))));
};

/* harmony default export */ var social_bar = (social_bar_SocialBar);
// CONCATENATED MODULE: ./src/components/desktop/common/footer/social-bar/index.js


/***/ })

}]);